import styled from 'styled-components';
export const AI_BRAND_COLOR_CYAN = '#00B6FF';
export const AI_BRAND_COLOR_MAGENTA = '#F800DB';

export const AI_BRAND_GRADIENT_HORIZONTAL =
    `linear-gradient(270deg, ${AI_BRAND_COLOR_MAGENTA} 0%, ${AI_BRAND_COLOR_CYAN} 100%)`;
export const AI_BRAND_GRADIENT_HORIZONTAL_HOVER =
    `linear-gradient(270deg, ${AI_BRAND_COLOR_CYAN} 0%, ${AI_BRAND_COLOR_MAGENTA} 100%)`;
export const AI_BRAND_GRADIENT_VERTICAL =
    `linear-gradient(180deg, ${AI_BRAND_COLOR_CYAN} 0%, ${AI_BRAND_COLOR_MAGENTA} 100%)`;
export const AI_BRAND_GRADIENT_BORDER_WIDTH = '5px';

export const triggerWrapper = styled.div<{ $cssStyle?: string }>`
    transition: all 300ms;
    & > button {
        color: var(--color-text-inverse-default);
        background: ${AI_BRAND_GRADIENT_HORIZONTAL};
        border: none;
        &:hover:not(:disabled) {
            background: ${AI_BRAND_GRADIENT_HORIZONTAL_HOVER};
        }
        ${p=>p.$cssStyle}
    }
`;
